import { api } from "../api/api";
import { IFileUpload } from "../components/FileUpload/FileUpload.type";

export const uploadFile = async (
	file: File | null,
	module_name: string,
	defaultReturn: string,
	asPayload: {
		[key: string]: string | number | null;
	}
) => {
	if (file) {
		const formdata = new FormData();
		formdata.append("files", file);
		formdata.append("module_name", module_name);
		formdata.append("as_payload", JSON.stringify(asPayload));
		const res = await api.post("/general/upload-files", formdata);
		const data: string[] = res.data.data;
		if (data.length > 0) {
			return data[0];
		}
	}
	return defaultReturn;
};

export const uploadMultipleFiles = async (
	files: IFileUpload[],
	module_name: string,
	asPayload: { [key: string]: string | number | null }
): Promise<string[]> => {
	let existingFiles: string[] = [];
	let noFileToUpload: boolean = true;
	const formdata = new FormData();
	for (const file of files) {
		if (file.path) {
			existingFiles.push(file.path);
		} else {
			noFileToUpload = false;
			formdata.append("files", file.file as File); // appending every file to formdata
		}
	}

	if (noFileToUpload) {
		return existingFiles;
	}

	formdata.append("module_name", module_name);
	formdata.append("as_payload", JSON.stringify(asPayload));
	const result = await api.post("/general/upload-files", formdata);

	return [...existingFiles].concat(result.data.data as string[]);
};

export const uploadImage = async (image: File | null) => {
	if (image) {
		const formdata = new FormData();
		formdata.append("image", image);
		const res = await api.post("/user/upload-image", formdata);
		const data: string = res.data.data[0].imagePath || "";
		if (data.length > 0) {
			return data;
		}
	}
};

export const uploadUserFile = async (
	file: File | null,
	defaultReturn: string = "",
	module_name: string = "USER",
	asPayload: { [key: string]: any } = {}
): Promise<string> => {
	if (file) {
		const formdata = new FormData();
		formdata.append("file", file);
		formdata.append("files", file);
		formdata.append("module_name", module_name);
		formdata.append("as_payload", JSON.stringify(asPayload));
		
		let res: any;
		try {
			res = await api.post("/user/upload-file", formdata);
		} catch (e: any) {
			if (e.response && (e.response.status === 404 || e.response.status === 405)) {
				res = await api.post("/api/v1/user/upload-file", formdata);
			} else {
				throw e;
			}
		}

		const resData = res?.data;
		if (typeof resData?.data === "string") {
			return resData.data;
		}
		if (Array.isArray(resData?.data) && resData.data.length > 0) {
			const item = resData.data[0];
			if (typeof item === "string") return item;
			if (item?.file_url) return item.file_url;
			if (item?.filePath) return item.filePath;
			if (item?.imagePath) return item.imagePath;
			if (item?.path) return item.path;
			if (item?.url) return item.url;
		}
		if (resData?.data && typeof resData.data === "object") {
			const item = resData.data;
			if (item.file_url) return item.file_url;
			if (item.filePath) return item.filePath;
			if (item.imagePath) return item.imagePath;
			if (item.path) return item.path;
			if (item.url) return item.url;
		}
		if (resData?.file_url) return resData.file_url;
		if (resData?.path) return resData.path;
		if (resData?.url) return resData.url;
	}
	return defaultReturn;
};

